import React, { useState } from "react";
import { Box, Chip } from "@mui/material";
import color from "../../../Constants/colors";
import VoicesInput from "./VoicesInput";

interface Props {
  value: string[];
  onChange: (terms: string[]) => void;
  placeholder: string;
}

const VoicesTermsInput: React.FC<Props> = ({ value, onChange, placeholder }) => {
  const [draft, setDraft] = useState("");

  const add = (text: string) => {
    const terms = [...value];
    text.split(",").forEach((term) => {
      const trimmed = term.trim();
      if (trimmed && !terms.includes(trimmed)) terms.push(trimmed);
    });
    if (terms.length !== value.length) onChange(terms);
    setDraft("");
  };

  return (
    <Box>
      <VoicesInput
        fullWidth
        size="small"
        value={draft}
        placeholder={placeholder}
        onChange={(event) => {
          const text = event.target.value;
          if (text.includes(",")) add(text);
          else setDraft(text);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            add(draft);
          }
        }}
        onBlur={() => draft.trim() && add(draft)}
      />
      {value.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}>
          {value.map((term) => (
            <Chip
              key={term}
              label={term}
              size="small"
              onDelete={() => onChange(value.filter((item) => item !== term))}
              sx={{
                maxWidth: "100%",
                backgroundColor: color.orange50,
                border: `1px solid ${color.orange200}`,
                color: color.gray900,
                "& .MuiChip-deleteIcon": { color: color.gray500 },
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default VoicesTermsInput;
